import { gql } from '@apollo/client'

// mutation name added
export default gql(`
    mutation createVirtualAsset($type:String! $title: String! $createdBy: String $project: String $module: String!) {
        createVirtualAsset(
            input: {
                type: $type
                title: $title
                createdBy: $createdBy
                project: $project
            }
            module : $module
        ) {
            id
            isArchived
            shortId
            externalId
            title
            type
            updatedAt
            publishStartDate
            publishEndDate
            autoPublish
            status
            isFree
            seasonNumber
            episodeNumber
            createdAt
            series{
                id
                assetId
                title
              }
              season{
                  id
                  assetId
                  title
              }
            defaultMedia {
                id
                fileName
                aspectRatio {
                    title
                    aspectRatio
                    resolutions {
                    url
                    }
                }
                settings {
                    aspectRatio
                    outputFormat
                    fileName
                    x1
                    y1
                    x2
                    y2
                }
            }
        }
    }`
)
